<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row no-gutters>
            <v-col cols="3"><h4>Elenco prodotti presenti nel sito eCommerce: {{ totaleArticoli ? totaleArticoli : '' }}</h4></v-col>
            <v-col cols="8" class="text--secondary"><span class="red--text">{{erroreAccesso}}</span></v-col>
            <v-col cols="1" v-if="open"><v-btn @click.stop="onScaricaProdotti">Aggiorna</v-btn></v-col>

          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row no-gutters>
          <v-col class="text-caption">Seleziona i prodotti eCommerce da creare nel Gestionale o associa quelli esistenti</v-col>
        </v-row>
        <!-- :items="mostraSoloNonAssociati ? articoliSorted.filter(x => !x.prodotto) : articoliSorted" -->
        <v-data-table
          v-model="selected"
          :show-select="totaleArticoli > 0"
          item-key="id"
          :headers="headers"
          :items="mostraSoloNonAssociati ?  prodottiNonAssociati : articoliSorted"
          :options.sync="options"
          
          :loading="loading"
          class="elevation-1"
          :disable-sort="true"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, 100]
          }"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          show-expand          
          dense
        >
        <!-- :server-items-length="totaleArticoli" -->
          <template v-slot:top>
            <v-row align="center" justify="end" dense>
              <v-col md="3" class="mb-3">
                <v-text-field v-model="filtroProdotto" dense outlined label="Ricerca per codice o descrizione" clearable hide-details ></v-text-field>
              </v-col>
            </v-row>
          </template>        
          <template v-slot:[`item.speciali`]="{ item }">
            <v-icon v-if="item.prodotto" small title="Associato a prodotto di magazzino" class="ml-2">mdi-cart-outline</v-icon>
          </template>        
          <template v-slot:[`item.name`]="{ item }">
            <div title="Visualizza prodotto online" @click="apriCommerce(item)" class="text-decoration-underline" style="cursor: pointer;">{{ item.name }}</div>
          </template> 
          <template v-slot:[`item.variations`]="{ item }">
            <span :title="item.attributes.length > 0 ? item.attributes[0].options.join(', ') : ''" style="cursor: help;">{{ item.variations.length }}</span>
          </template>
          <template v-slot:[`item.images`]="{ item }">
            <v-img v-if="item.images.length > 0" :src="item.images[0].src" max-width="50"></v-img>
          </template>
          <template v-slot:no-data>
            <h3 class="m-3">Per popolare la lista scarica l'elenco dei prodotti dal sito !!</h3>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="articoliSelected">
              <v-tabs dense v-model="tab[item._id]">
                <v-tab key="associaProdotto" class="articoliSelected">{{item.prodotto ? 'Prodotto associato' : 'Associa prodotto esistente'}}</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab[item._id]">
                <v-tab-item key="associaProdotto">
                  <!-- <prodotto-associato v-if="item.prodotto" :item="item" @aggiorna="associaProdotto"/> -->
                  <associa-prodotto-esistente :item="item" :prodottiAbilitatiECommerce="prodottiAbilitatiECommerce" :trigger="trigRefresh" @aggiorna="associaProdotto"/>
                </v-tab-item>   
              </v-tabs-items>
            </td>
          </template>  
          <template v-slot:[`footer.prepend`]>
            <v-switch v-model="mostraSoloNonAssociati" class="pb-2" dense inset label="Mostra solo non associati"></v-switch>
            <v-btn v-if="selected.length > 0" color="primary" class="ml-5" @click="onCreaProdottiMagazzino">Crea articoli di magazzino</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" class="mr-5 mb-2" @click="onImportaAssociazioni" title="File Codice gestionale / Codice eCommerce per mappatura prodotti">Importa excel associazioni</v-btn>
            <v-file-input
              v-model="filename"
              accept=".csv, .xls, .xlsx"
              label="File associazioni"
              show-size
              outlined
              dense
              prepend-icon=""
              prepend-inner-icon="$file"
              class="mt-5 mr-5"
              @change="onChange"
            ></v-file-input>
          </template>
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  import configurazioni from '@/services/configurazioniService.js'
  import prodotti from '@/services/prodottiService.js'
  import { sanitize } from '@/components/helpers'
  import eCommerce from '@/services/eCommerceService'
  import AssociaProdottoEsistente from './associaProdottoEsistente'
  import * as _ from 'lodash'
  import * as XLSX from 'xlsx'
  import * as dot from 'dot-object'
  // import ProdottoAssociato from './prodottoAssociato'

  export default {
    components: {
      AssociaProdottoEsistente
      // ProdottoAssociato
    },
    props: {
    },
    data: () => ({
        totaleArticoli: 0,
        articoli: [],
        selected: [],
        loading: false,
        options: { itemsPerPage: 15 },
        headersDefault: [ // Caricato se non ci sono impostazioni diverse nel DB
          { text: 'Codice', value: 'id', align: 'start' },
          { text: 'Nome', value: 'name' },
          { text: 'Slug', value: 'slug' },
          /* { text: 'Descrizione', value: 'description' }, */
          { text: 'Prezzo €', value: 'price', align: 'end' },
          { text: 'Listino €', value: 'regular_price', align: 'end' },
          { text: 'Offerta €', value: 'sale_price', align: 'end' },
          
          { text: 'Giacenza', value: 'stock_quantity', align: 'end' },
          { text: 'Opzioni', value: 'variations', align: 'center' },
          { text: 'Foto', value: 'images', align: 'start' },
          { text: '', value: 'data-table-expand' }
        ], 
        headersSpeciali: [
          { text: '', value: 'speciali', width: 80 }
        ],   
        headersBO: [],
        mostraSoloNonAssociati: true,
        datiFiscali: null,
        nomeAttributoTaglia: 'Taglia',
        nomeAttributoColore: 'Colore',
        trigRefresh: 1,
        expanded: [],
        singleExpand: false,
        tab: {},
        prodottiAbilitatiECommerce: [],
        filtroProdotto: '',
        erroreAccesso: '',
        prodottiNonAssociati: [],
        filename: null,
        nomeFile: '',
        colonneModello: [],
        showImporta: false,
        book: null,
        sheetNum: 0,
        sheetNames: [],
        datiAssociazione: []
    }),
    async mounted() {
      const backoffice = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.headersBO = _.get(backoffice, 'eCommerce.griglia.headers', this.headersDefault)
      this.datiFiscali = _.get(backoffice, 'eCommerce.datiFiscali')
      this.nomeAttributoTaglia = _.get(backoffice, 'eCommerce.nomeAttributoTaglia')
      this.nomeAttributoColore = _.get(backoffice, 'eCommerce.nomeAttributoColore')
      await this.onScaricaProdotti()
      await this.calcolaTotali()
    },
    computed: {
      headers() {
        return this.headersSpeciali.concat(this.headersBO)
      },      
      articoliSorted() {
        if (this.filtroProdotto && this.articoli) {
          return this.articoli.filter(x => String(x.id).startsWith(this.filtroProdotto) || x.name.toLowerCase().includes(this.filtroProdotto.toLowerCase()))
        }
        console.log(this.articoli)
        return this.articoli || []
      },
      getNonAssociati() {
        // NON calcola correttamente ... verificare su caso reale
        const numero = this.articoli.filter(x => !x.prodotto).length
        return numero > 0 ? `${numero} articoli non sono associati a prodotti del gestionale` : ''
      }
    },
    watch: {
      options: {
        async handler () {
          await this.onScaricaProdotti()
        },
        deep: true
      },
      resetFile() {
        this.filename = null
      }      
    },    
    methods: {
      async getProdottiNonAssociati() {
        let prodottiEC = await eCommerce.scaricaTuttiProdotti()
        this.articoli = prodottiEC
        await this.verificaCreati()
        this.prodottiNonAssociati = prodottiEC.filter(x => !x.prodotto)
      },
      async calcolaTotali() {
        const totali = await eCommerce.getTotaleProdotti()
        this.totaleArticoli = 0
        for (let t of totali) {
          this.totaleArticoli += t.total
        }
      },
      async onScaricaProdotti() {
        this.loading = true
        await this.getProdottiNonAssociati()
/*         const result = await eCommerce.getElencoProdotti(this.options)
        result.status === 'error' ? this.erroreAccesso = result.message : ''
        this.articoli = result.prodotti */
        // await this.verificaCreati()
        this.loading = false
      },
      async verificaCreati_old() {
        const ids = this.articoli.map(x => x.id)
        // Per rapidità suppongo che l'id del prodotto di magazzino corrisponda a quella eCommerce
        // TODO: Creare comne standard e sistemare le query di verifica per prodotti eCommerce
        // La stessa funzione serve quando arriva un ordine su Webhook per cercare il prodotto correlato a quello ordinato

        const creati = await prodotti.getProdottiByIds(ids)
        for (let itm of creati) {
          let peC = this.articoli.find(x => String(x.id) === itm._id)
          peC.prodotto = true
        }
      },
      async verificaCreati() {
        const creati = await prodotti.getProdottiEcommerce(true)
        this.prodottiAbilitatiECommerce = creati

        for (let itm of creati) {
          // Negli articoli, trova sia quelli con variazioni che quelli semplici ?
          let peC = this.articoli.find(x => String(x.id) === String(itm.eCommerce.id))
          if (peC) {
            peC.prodotto = true
            peC.ubisell = {
              _id: itm._id,
              codice: itm.codice,
              descrizione: itm.descrizione,
              varianti: itm.varianti
            }
          } else {          
            let conVariazioni = this.articoli.find(x => x.variations.some(v => String(v) === String(itm.eCommerce.id)))
            if (conVariazioni) {
              conVariazioni.numAssociati = conVariazioni.numAssociati || conVariazioni.variations.length
              conVariazioni.numAssociati--
              conVariazioni.ubisell = conVariazioni.ubisell || {}
              conVariazioni.ubisell[String(itm.eCommerce.id)] = {
                _id: itm._id,
                codice: itm.codice,
                descrizione: itm.descrizione,
                varianti: itm.varianti
              }              
              if (conVariazioni.numAssociati <= 0) {
                conVariazioni.prodotto = true
              } else {
                conVariazioni.prodotto = false
              }
            }
          }
          // TODO: Deve verificare se tutte le variazioni sono state associate
        }

      },      
      apriCommerce(item) {
        if (item.permalink) {
          window.open(item.permalink)
        }
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      },      
      async onCreaProdottiMagazzino() {
        this.loading = true
        for (let pr of this.selected.filter(x => !x.prodotto)) {
          const modello = await prodotti.getModello()
          let prodotto = _.cloneDeep(modello)
          prodotto._id = String(pr.id)
          prodotto.codice = String(pr.id)
          // prodotto.descrizione = pr.name
          prodotto.eCommerce = await eCommerce.mapInfoProdotto(pr)
          prodotto.descrizione = prodotto.eCommerce.nome
          prodotto.ricercaBarcode = prodotto.eCommerce.barcode
          prodotto.barcode = prodotto.barcode || []
          prodotto.barcode.push({
            codice: prodotto.eCommerce.barcode,
            attivo: true,
            importOn: 'Ecommerce'
          })
          if (pr.type === 'variable') {
            // simple o option non diventano prodotti base ma possono essere venduti
            prodotto.eCommerce.prodottoBase = true // NON può essere venduto
          }
          //TODO: Manca aliquotaIva e reparto fiscale
          if (this.datiFiscali) {
            prodotto.datiFiscali = this.datiFiscali
          }
          _.set(prodotto, 'prezzo.L1.base', +parseFloat(prodotto.eCommerce.prezzo).toFixed(2))
          // TODO: Verificare: E' prevista la giacenza sul prodotto master ? Si tratta della somma di tutte le opzioni ?
          _.set(prodotto, 'magazzino.giacenza', prodotto.eCommerce.giacenza)
          await prodotti.creaProdotto(prodotto)
          for (let vv of pr.variations) {
            // Deve creare i singoli prodotti in base alla variazione
            const infoP = await eCommerce.getInfoProdotto(vv, true)
            if (infoP.id) {
              prodotto = _.cloneDeep(modello)
              
              prodotto.codice = String(pr.id)
              prodotto.descrizione = infoP.name || pr.name
              prodotto.eCommerce = await eCommerce.mapInfoProdotto(infoP)
              _.set(prodotto, 'prezzo.L1.base', +parseFloat(prodotto.eCommerce.prezzo).toFixed(2))
              if (prodotto.eCommerce.listino) {
                _.set(prodotto, 'prezzo.L2.base', +parseFloat(prodotto.eCommerce.listino).toFixed(2))
              }
              _.set(prodotto, 'magazzino.giacenza', prodotto.eCommerce.giacenza)
              const tagliaOpt = infoP.attributes.find(x => x.name === this.nomeAttributoTaglia)
              const tagliaDescrizione = tagliaOpt ? tagliaOpt.option : ''
              const tagliaCodice = sanitize(tagliaDescrizione).replace('-', '_')

              const coloreOpt = infoP.attributes.find(x => x.name === this.nomeAttributoColore)
              const coloreDescrizione = coloreOpt ? coloreOpt.option : ''
              const coloreCodice = sanitize(coloreDescrizione).replace('-', '_')

              if (tagliaOpt) {
                _.set(prodotto, 'varianti.variante1', {
                  codice: tagliaCodice,
                  descrizione: tagliaDescrizione
                })
              }
              if (coloreOpt) {
                _.set(prodotto, 'varianti.variante2', {
                  codice: coloreCodice,
                  descrizione: coloreDescrizione
                })
              }
              prodotto._id = prodotti.creaCampoRicercaTC_Codici(pr.id, tagliaCodice, coloreCodice)
              await prodotti.creaProdotto(prodotto)
            }
          }
        }
        await this.verificaCreati()
        await prodotti.clearCache()
        this.$emit('refresh')
        this.loading = false
        this.annullaSelezione()
      },
      async onImportaAssociazioni() {
        const datiFlat = this.flatDatiRaw(this.datiAssociazione)
        const ids = datiFlat.map(x => x.codiceGestionale)
        if (ids.length > 0) {
          const elenco = await prodotti.getProdottiByIds(ids)
          for (let p of elenco) {
            let d = datiFlat.find(x => x.codiceGestionale === p._id)
            p.eCommerce = {
              id: d.codiceEcommerce,
              abilita: true
            }
            await prodotti.aggiornaProdotto(p)
          }
        }
      },
      async associaProdotto() {
        this.loading = true
        for (let p of this.articoli.filter(x => x.prodotto)) {
          delete p.prodotto
          delete p.ubisell
        }
        await this.verificaCreati()
        await prodotti.clearCache()
        this.$emit('refresh')
        this.loading = false
        this.annullaSelezione()
        await this.$nextTick()
        this.trigRefresh++
      },
      // ***************************************************************
      str2ab(str) {
        var buf = new ArrayBuffer(str.length)
        var bufView = new Uint8Array(buf)
        for (var i = 0, strLen = str.length; i < strLen; i++) {
          bufView[i] = str.charCodeAt(i)
        }
        return buf
      },
      onChange(file) {
        if (!file) {
          this.sheetNames = []
          this.sheetNum = 0
          this.book = null

          return
        }
        const nomeFile = file.name
        const fr = new FileReader()
        fr.readAsDataURL(file)
        fr.addEventListener('load', async () => {
          this.nomeFile = nomeFile
          const content = fr.result
          const data = atob(content.substring(content.indexOf(',') + 1))
          var fileData = this.str2ab(data)
          const book = XLSX.read(fileData, { type: 'array' })
          this.book = book
          this.sheetNames = book.SheetNames
          await this.afterRead()
        })
      },
      async afterRead() {
        const book = this.book
        const sheetNum = this.sheetNum
        const sheetName = book.SheetNames[+sheetNum]
        const sheet = book.Sheets[sheetName]
        let dati = this.dataFromSheet(sheet)
        const datiPuliti = []
        if (dati && dati.length > 0) {
          const toDelete = Object.keys(dati[0]).filter(x => x.startsWith('__EMPTY'))
          if (toDelete) {
            dati.forEach(riga => {
              const rg = _.omit(riga, toDelete)
              if (!_.isEmpty(rg)) {
                datiPuliti.push(rg)
              }
            })
          }
          dati = null
        }
        // ****************  Elaborare i dati in base al modello  **********************
        const elenco = await configurazioni.getConfigurazione('import_dati', 'modelli')
        const modello = elenco.custom.find(x => x.codice === 'associazioneEcommerce')
        const datiModello = []
        const codiceModello = modello.codice
        if (codiceModello && datiPuliti.length > 0) {
          let idxRiga = modello.prima_riga_dati || 2
          datiPuliti.forEach(riga => {
            const rigaM = {}
            modello.colonne.forEach(col => {
              if (col.colonnaSorgente) {
                rigaM[col.campo] = riga[col.colonnaSorgente]
              } else {
                const idx = col.colonna - 1
                const colName = `${String.fromCharCode(65 + idx)}${idxRiga}`
                var cell = sheet[colName]
                let valore = (cell ? cell.v : '')
                if (col.fattore && valore) {
                  valore *= col.fattore
                }
                if (col.offset) {
                  valore += col.offset
                }
                if (col.decimali && valore) {
                  valore = +parseFloat(valore).toFixed(col.decimali)
                }
                rigaM[col.campo] = valore
              }
              if (typeof rigaM[col.campo] === 'string') {
                rigaM[col.campo] = rigaM[col.campo].trim()
              }
            })
            if (rigaM.codiceFornitore) {
              datiModello.push(rigaM)
            }
            idxRiga++
          })
        }
        this.datiAssociazione = datiPuliti
        // const datiFlat = this.flatDatiRaw(datiPuliti)
      },
      flatDatiRaw(dati) {
        let datiRaw = []
        for (let d of dati) {
          datiRaw.push(dot.dot(d)) 
        }
        return datiRaw
      },

/*       async asyncSome (arr, predicate) {
        for (const e of arr) {
          if (await predicate(e)) return true
        }
        return false
      }, */
      dataFromSheet(sheet) {
        const json = XLSX.utils.sheet_to_json(sheet)
        return this.dataFromJSON(json)
      },
/*       jsonFromSheet(sheet) {
        return XLSX.utils.sheet_to_json(sheet)
      },
      htmlFromSheet(sheet) {
        return XLSX.utils.sheet_to_html(sheet, { header: '', footer: '' })
      }, */
      dataFromJSON(json) {
        _.forEach(json, row => {
          dot.object(row)
        })
        return json
      }      
    }
  }
</script>
